import React from 'react';

import { DataPipeline } from '@finley-technologies/finley-types';

import { AssignmentActions } from './actions/AssignmentActions';
import { FundingRequestActions } from './actions/FundingRequestActions';
import { getCustomError as limitedPartnersError } from './LimitedPartners/LimitedPartnersCustomError';
import { getCustomError as receivableReconciliationError } from './ReceivableReconciliation/ReceivableReconciliation';
import { CustomError } from '~/packages/dataPipeline/types/dataPipelineTypes';

// The drawer's domain-specific additions, in one place, so the drawer core
// names no domain. Each entry checks the run's graph itself and renders
// nothing when it has no such node (a BUS graph shows none of them).
// Exception: an input's receivable reconciliation stays in UploadSingleInput,
// since it takes part in that input's retry.

// sections below the run's uploads, in this order
export const drawerRunActions: ReadonlyArray<{
  key: string;
  Component: () => React.ReactElement;
}> = [
  { key: 'assignment', Component: AssignmentActions },
  { key: 'fundingRequest', Component: FundingRequestActions },
];

export type RunErrorExplainer = (run: {
  artifacts: DataPipeline.Artifact[];
  instances: DataPipeline.Instance[];
}) => CustomError | null;

// explain a failed run better than the generic message; the first match wins
export const drawerErrorExplainers: ReadonlyArray<RunErrorExplainer> = [
  ({ artifacts, instances }) =>
    receivableReconciliationError(artifacts, instances),
  limitedPartnersError,
];
